import { exceptionTypeMap } from './types';

export const FINDING_STATE_LABELS: Record<string, string> = {
  ACTIVE: 'Active',
  INACTIVE: 'Undetected',
};

export const FILTER_FIELD_LABEL_MAPPINGS: Record<string, Record<string, string>> = {
  'exception.type': exceptionTypeMap,
};
